import { isAppRoute } from "@/lib/cross-surface";

const APP_BUILD_TAG = "app-build-tag";
const MARKETING_BUILD_TAG = "marketing-build-tag";

type Surface = "app" | "marketing" | "unknown";

function loadedSurface(): Surface {
  const tag = document
    .querySelector('meta[name="x-build"]')
    ?.getAttribute("content");
  if (tag === APP_BUILD_TAG) return "app";
  if (tag === MARKETING_BUILD_TAG) return "marketing";
  return "unknown";
}

function urlWantsApp(): boolean {
  const path =
    window.location.pathname +
    window.location.search +
    window.location.hash;
  return isAppRoute(path);
}

function bundleMatchesUrl(): boolean {
  const surface = loadedSurface();
  if (surface === "unknown") return true;
  return urlWantsApp() ? surface === "app" : surface === "marketing";
}

function reconcileCrossSurfaceHistory(): void {
  if (bundleMatchesUrl()) return;
  window.location.assign(window.location.href);
}

/**
 * Dual-origin SPAs share one origin; browser back can restore the wrong
 * bundle from bfcache while the URL points at the other surface.
 */
export function installCrossSurfaceHistoryGuard(): void {
  if (typeof window === "undefined" || import.meta.env.DEV) return;

  window.addEventListener("popstate", reconcileCrossSurfaceHistory);
  window.addEventListener("pageshow", (event) => {
    if (event.persisted) reconcileCrossSurfaceHistory();
  });
}
